import { BondFilter } from "./BondFilter";
import { BondFilterAdvanced } from "./filters/BondFilterAdvanced";
import { BondFilterFavoriteIcon } from "./filters/BondFilterFavorite";
import { BondFilterIndustry } from "./filters/BondFilterIndustry";
import { BondFilterMaturity } from "./filters/BondFilterMaturity";
import { BondFilterMinimumAmount } from "./filters/BondFilterMinimumAmount";
import { BondFilterPurchasePrice } from "./filters/BondFilterPurchasePrice";
import { BondFilterSearch } from "./filters/BondFilterSearch";
import { BondFilterYield } from "./filters/BondFilterYield";
import { BondFilterRating } from "./filters/rating/BondFilterRating";

export const bondFilterFavorite = new BondFilterFavoriteIcon();
export const bondFilterSearch = new BondFilterSearch();

export const bondFilters: BondFilter[] = [
  new BondFilterMaturity(),
  new BondFilterYield(),
  new BondFilterRating(),
  new BondFilterIndustry(),
  new BondFilterPurchasePrice(),
  new BondFilterAdvanced(),
  new BondFilterMinimumAmount(),
  bondFilterFavorite,
  bondFilterSearch,
];
